module.exports = __webpack_public_path__ + "static/media/Card2partner.69996403.png";